import { render } from "./HeroAddAnnouncementModal.vue?vue&type=template&id=229c4a0a&scoped=true"
import script from "./HeroAddAnnouncementModal.vue?vue&type=script&lang=js"
export * from "./HeroAddAnnouncementModal.vue?vue&type=script&lang=js"

import "./HeroAddAnnouncementModal.vue?vue&type=style&index=0&id=229c4a0a&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229c4a0a"]])

export default __exports__